import React, { useState } from "react";
import { View, TouchableOpacity } from "react-native";
import FontAwesome5 from "react-native-vector-icons/FontAwesome5";
import { theme } from "@common/theme/theme";
import TextM from "@common/components/text/TextM";
import { IS_WEB } from "@common/utils/mobileUtils";
import MicrophoneLevelBars from "./MicrophoneLevelBars";
import { useMicrophoneLevel } from "../../../engine/precall/useMicrophoneLevel";

/**
 * Microphone level indicator with real-time audio level visualization
 * Automatically starts/stops mic test based on permissions
 * Shows help modal with troubleshooting tips
 */
const MicrophoneLevelIndicatorM = ({ permissionsGranted, style, hideHelpButton = false, showFullHelpButton = false, isSoundMode }) => {
    const [showHelpModal, setShowHelpModal] = useState(false);
    const micLevel = useMicrophoneLevel(permissionsGranted);

    // Lazy load the modal to break the require cycle
    const MicrophoneHelpModal = showHelpModal
        ? require("./MicrophoneHelpModal").default
        : null;

    return (
        <View style={style}>
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <MicrophoneLevelBars micLevel={micLevel} />
                {IS_WEB && permissionsGranted?.microphone && !hideHelpButton && (
                    showFullHelpButton ? (
                        <TouchableOpacity
                            onPress={() => setShowHelpModal(true)}
                            style={{
                                marginLeft: 12,
                                backgroundColor: theme.colors.lighter,
                                paddingHorizontal: 12,
                                paddingVertical: 6,
                                borderRadius: 15,
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            <FontAwesome5
                                name="question-circle"
                                size={14}
                                color={theme.colors.primary}
                                style={{ marginRight: 6 }}
                            />
                            <TextM fontSize={12} color={theme.colors.primary}>
                                Aide
                            </TextM>
                        </TouchableOpacity>
                    ) : (
                        <TouchableOpacity
                            onPress={() => setShowHelpModal(true)}
                            style={{ marginLeft: 8 }}
                        >
                            <FontAwesome5
                                name="question-circle"
                                size={20}
                                color={theme.colors.grey}
                            />
                        </TouchableOpacity>
                    )
                )}
                {!permissionsGranted?.microphone && (
                    <TouchableOpacity
                        style={{ marginLeft: 8 }}
                    >
                        <FontAwesome5
                            name="exclamation-triangle"
                            size={20}
                            color={theme.colors.warning}
                        />
                    </TouchableOpacity>
                )}
            </View>

            {MicrophoneHelpModal && (
                <MicrophoneHelpModal
                    visible={showHelpModal}
                    onDismiss={() => setShowHelpModal(false)}
                    isSoundMode={isSoundMode}
                />
            )}
        </View>
    );
};

export default MicrophoneLevelIndicatorM;
